import { render, staticRenderFns } from "./Activity14.vue?vue&type=template&id=2027e95e&scoped=true"
import script from "./Activity14.vue?vue&type=script&lang=js"
export * from "./Activity14.vue?vue&type=script&lang=js"
import style0 from "./Activity14.vue?vue&type=style&index=0&id=2027e95e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2027e95e",
  null
  
)

export default component.exports